import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { getDate } from '../../../../utils/dateTime'
import { formatBillingCycle, getFormattedPrice } from '../../utils'
import { BILLING_CYCLE_TYPE, PAYMENT_METHOD_CODES } from '../../constants'
import { PaymentMethod } from './PaymentMethod'
import { ActiveSectionMobile } from './ActiveSectionMobile'
import { ActiveSectionDesktop } from './ActiveSectionDesktop'

export const SubscriptionItem = ({ isMobile, subscription, onUpdateRecurringOption, isLoading }) => {
    const { t } = useTranslation()
    const {
        expirationDate,
        product: { billingCycleType, billingCycleValue, name: productName },
        lastPayment,
        started,
        recurringEnabled,
        selected,
        subscriptionReference,
    } = subscription

    const price = lastPayment ? getFormattedPrice(lastPayment.price, lastPayment.currency) : 'N/A'

    const canControlRecurring =
        selected &&
        subscriptionReference &&
        lastPayment !== null &&
        lastPayment.paymentMethodCode !== PAYMENT_METHOD_CODES.FREE

    const onUpdateRecurring = value => {
        onUpdateRecurringOption(value)
    }

    return (
        <Fragment>
            <div className="subscriptions__state__row" style={{ minHeight: '100px' }}>
                <div className="subscriptions__state__item-desktop subscriptions__state__item-mobile">
                    <span className="subscriptions__state__item-title">{t('Your active subscription')}</span>
                    <p className="subscriptions__state__item-active-value">{productName.split(' ')[0]}</p>
                </div>
                <div className="subscriptions__state__item-desktop subscriptions__state__item-mobile">
                    <span className="subscriptions__state__item-title">{t('Price')}</span>
                    <p className="subscriptions__state__item-value">{price}</p>
                </div>
                <div className="subscriptions__state__item-desktop subscriptions__state__item-mobile">
                    <span className="subscriptions__state__item-title">{t('Cycle')}</span>
                    <p className="subscriptions__state__item-value">{formatBillingCycle(billingCycleType, t)}</p>
                </div>
                <div className="subscriptions__state__item-desktop subscriptions__state__item-mobile">
                    <span className="subscriptions__state__item-title">{t('Started')}</span>
                    <p className="subscriptions__state__item-value">{getDate(started)}</p>
                </div>
                <div className="subscriptions__state__item-desktop subscriptions__state__item-mobile">
                    <span className="subscriptions__state__item-title">{t('Last payment')}</span>
                    <p className="subscriptions__state__item-value">
                        {lastPayment ? getDate(lastPayment.saleDate) : 'N/A'}
                    </p>
                </div>
                <PaymentMethod lastPayment={lastPayment} isMobile={isMobile} />
                {isMobile ? (
                    <ActiveSectionMobile
                        recurringEnabled={recurringEnabled}
                        expirationDate={expirationDate}
                        billingCycleValue={billingCycleValue}
                        canControlRecurring={canControlRecurring}
                        onUpdateRecurring={onUpdateRecurring}
                        isLoading={isLoading}
                    />
                ) : (
                    <ActiveSectionDesktop
                        recurringEnabled={recurringEnabled}
                        expirationDate={expirationDate}
                        billingCycleValue={billingCycleValue}
                        canControlRecurring={canControlRecurring}
                        onUpdateRecurring={onUpdateRecurring}
                        isLoading={isLoading}
                    />
                )}
            </div>
        </Fragment>
    )
}
